import { parseSignatureRequest } from '../../../utils/documentParserGQL';

export default (documents, currentOrganization, user) => documents.map(document => ({
  ...parseSignatureRequest(document, currentOrganization, user),
  type: 'waitingForMe',
}));
